
import React from 'react'

function Welcome2() {
    return (
        <section id="welcome">
            <div className="block color-scheme-1">

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-9">
                            <div className="section-sub-title center">
                                <article className="section-title-body white">

                                    <h1 className="head-title">
                                        <span style={{ fontWeight: '700' }}>
                                            Celebrate Your Life with the Hindu Way of living
                                        </span>
                                    </h1>

                                    <p className="head-text">
                                        AMERICANS4HINDUS (A4H) unites culture, community,
                                        civic participation and leadership development into one
                                        national platform dedicated to uplifting Hindu Americans
                                        and pro-Hindu allies across the United States. Through
                                        festivals, education, youth programs, and leadership
                                        training, we strengthen identity, amplify our collective
                                        voice, and empower every generation to lead with confidence.
                                    </p>

                                    <div className="why-a4h-section">

                                        <h2
                                            className="head-title why-a4h-title"
                                            style={{ marginTop: '40px' }}
                                        >
                                            <span style={{ fontWeight: '700' }}>
                                                WHY AMERICANS4HINDUS NAME
                                            </span>
                                        </h2>

                                        <p
                                            className="head-text"
                                            style={{ textAlign: 'left' }}
                                        >
                                            While Founding this Superpac, we had lots of
                                            discussions on this topic. Reasons for picking the
                                            name as A4H is the following:
                                        </p>

                                        <div className="head-text">

                                            <p
                                                className="head-text"
                                                style={{ textAlign: 'left' }}
                                            >
                                                1. We are Americans First.
                                            </p>

                                            <p
                                                className="head-text"
                                                style={{ textAlign: 'left' }}
                                            >
                                                America is our Karmabhoomi.
                                                <br />
                                                For first generation Immigrants, India is the
                                                Janmabhoomi.
                                                <br />
                                                But for second generation onwards, Janmabhoomi
                                                is also America.
                                                <br />
                                                For them India is the Dharmabhoomi, land of their
                                                Roots.
                                            </p>

                                            <p
                                                className="head-text"
                                                style={{ textAlign: 'left' }}
                                            >
                                                
                                                    2. Americans will include Hindus and Pro-Hindus
                                                    who believe in our Ideology and Philosophy of
                                                    Hindus and Hinduism. Christians and Jews would not like to be called
                                                Hindus but as Americans for Hindu Values nobody
                                                will have any issues.
                                                
                                            </p>

                                            

                                            <p
                                                className="head-text"
                                                style={{ textAlign: 'left' }}
                                            >
                                                
                                                    3. Americans4Hindus reflects not Hindus as
                                                    persons but Hindu Values, Philosophy, Ideals,
                                                    Culture and Civilization.For simplicity and curiosity for further
                                                discussion, we left it at Hindus.
                                                
                                            </p>

                                            

                                            <p
                                                className="head-text"
                                                style={{ textAlign: 'left' }}
                                            >
                                                
                                                    4. As Americans we also plan to support and
                                                    promote Hindus and Hinduism all over the world
                                                    including India.Being Americans gives us more credibility and
                                                credence to be more effective and impactful in our
                                                Mission.
                                                
                                            </p>

                                           

                                            <p
                                                className="head-text"
                                                style={{ textAlign: 'left' }}
                                            >
                                                
                                                    5. Hindu Organizations are plenty and we work
                                                    with many of them very closely.But we would also like Pro-Hindu non-desis also
                                                join us in this Movement.
                                                
                                            </p>

                                            

                                        </div>

                                    </div>

                                </article>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default Welcome2
